var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"error-page"},[_c('Header',{attrs:{"routerType":"replace"}}),_c('div',{staticClass:"main"},[_c('Empty',{attrs:{"icon":require('@/assets/images/缺省插图-找不到页面.png')}})],1),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }